module.exports = __webpack_public_path__ + "static/media/faq-registry.d75cc1fd.svg";